<template lang="">
    <div class="content__trajet bilan__Assure bg-white shadow pb-2">
        <h2 class="text-center m-0 py-3 text-default">
            Bilan global du patient
        </h2>
        <hr class="m-0" />
        <div class="bilan__Assure--content">
            <ul class="bilan__Assure--content--text" style="padding-left: 0px">
                <li class="text-default py-3">
                    <span class="text-muted">
                        <i class="fa fa-user" aria-hidden="true"></i>
                        Total lignes de temps : 
                    </span>
                    {{ ligne_temp_length }}
                </li>
                <li class="text-default py-3">
                    <span class="text-muted">
                        <i class="fa fa-calendar" aria-hidden="true"></i>
                        Temps moyen de prise en charge : 
                    </span>
                    {{ temps_max_prise_en_charge }}
                </li>
                <li class="text-default py-3">
                    <span class="text-muted mr-md-5 mt-3 mt-lg-0">
                        <i class="fa fa-mobile" aria-hidden="true"></i>
                        Fiche signalitique : 
                    </span>
                    <a href="#" class="btn btn-outline-primary" @click="ficheSignalitique()">visualiser</a>
                </li>
              
                <li class="text-primary py-3">
                    
                    <div class="row justify-content-center">
                        <span class="border border-primary rounded col-12 col-md-5 text-center py-2">
                        <h2 >
                            <span class="text-muted my-0">
                                 <i class="fa fa-calculator" aria-hidden="true"></i>
                                Total : <span class="fw-bold text-primary my-0">
                                    {{ total_validation_globale.total_souscripteur }}
                                </span>
                            </span>
                           
                        </h2>
                    </span>
                    </div>
                </li>
                <div class="pt-2 d-flex justify-content-between">
                    <button type="button" class="d-flex align-items-center btn btn-primary bg-transparent text-primary 
                    shadow-none p-2 px-md-3" @click="bilanFinancier()">
                    <span class="d-none d-md-block">Télécharger </span><i class="fas fa-cloud-download-alt fa-2x"></i></button>
                    
                </div>
            </ul>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import AppConfig from "../../constants/AppConfig";
export default {
    name: "BilanAssure",
    computed: {},
    props: ['dossier_medical_slug', 'ligne_temp_length', 'temps_max_prise_en_charge'],
    data() {
        return {
            total_validation_globale: {total_praticien: "", total_medecin_controle: "", total_souscripteur: "", sexe: "", telephone:"", age: ""},
            total_validation_globale: {total_praticien: "", total_medecin_controle: "", total_souscripteur: "", sexe: "", telephone:"", age: ""},
        }
    },

    methods: {
        bilanFinancier (){
            axios.get(AppConfig.apiUrl+`/bilans/financiers/${this.dossier_medical_slug}`, {headers: {'Authorization': "Bearer " + localStorage.getItem('ms-token')}}).then(res => {
                window.open(res.data.link, "_blank"); 
            }).catch(error => {
                console.log('error ', error);
            })
        },
        ficheSignalitique(){
            //
        },
        displayNumber(value) {
            return Number(value).toLocaleString("fr") + " XAF";
        },
        computeBilanGlobal(dossier_medical_slug){
            axios.get(AppConfig.apiUrl+`/bilans/globale/${dossier_medical_slug}/financiers`, {headers: {'Authorization': "Bearer " + localStorage.getItem('ms-token')}}).then(res => {
            
                this.total_validation_globale.total_praticien = this.displayNumber(res.data.total_prescription)
                this.total_validation_globale.total_medecin_controle = this.displayNumber(res.data.total_medecin_controle)
                this.total_validation_globale.total_souscripteur = this.displayNumber(res.data.total_medecin_assureur)
                this.total_validation_globale.sexe = res.data.sexe
                this.total_validation_globale.telephone = res.data.telephone
                this.total_validation_globale.age = res.data.age
            
            }).catch(error => {
                console.log('error ', error);
            })
        },
    },
    mounted() {
        this.computeBilanGlobal(this.dossier_medical_slug);
    }
}
</script>
<style lang="">
    
</style>